var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NominateForm',{ref:"NominateForm",staticClass:"content",attrs:{"invalid":_vm.isSubmitting},on:{"submit":_vm.submit,"submit-and-pay":_vm.submitAndPay}})}
var staticRenderFns = []

export { render, staticRenderFns }